import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "conferences",
  "use": "conferences-usage",
  "viewBox": "0 0 86.867 100.187",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 86.867 100.187\" id=\"conferences\"><path d=\"M45.055 95.207l.005-44.127 38.442-22.193.03 44.213zm-34.26-17.883L3.333 88.879V28.882l38.394 22.197-.005 44.12zM81.832 26L43.394 48.192 5 25.995l38.431-22.15zm5.002-.963L43.432-.003 0 25.03v75.157l11.873-18.39 31.512 18.214 43.48-24.984-.031-49.99\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol